import { z } from 'zod';
import { lineSchema } from './lineSchema';
import { reactionProductSchema } from './reactionProductSchema';
import { annotationSchema } from './annotationSchema';

export const overlayLeftReactionSchema = z.object({
  id: z.number(),
  notes: z.string(),
  reactionId: z.string(),
  name: z.string(),
  reversible: z.boolean(),
  visibilityLevel: z.string().nullable(),
  z: z.number(),
  map: z.number(),
  kinetics: z.record(z.unknown()).nullable(),
  line: lineSchema,
  processCoordinates: z.null(),
  modifiers: z.array(reactionProductSchema),
  reactants: z.array(reactionProductSchema),
  products: z.array(reactionProductSchema),
  elementId: z.string(),
  operators: z.array(z.unknown()),
  references: z.array(annotationSchema),
  sboTerm: z.string(),
});
